module.exports = __webpack_public_path__ + "static/media/King-in-the-north.c747f57a.jpg";